import { RHINO_STORY_BODY, RHINO_STORY_META } from "./rhinoStory.js";

export const STORIES = [
  {
    ...RHINO_STORY_META,
    body: RHINO_STORY_BODY,
  },
];

/** @param {string} id */
export function getStoryById(id) {
  return STORIES.find((story) => story.id === id);
}

/** @param {string} id @param {number} [limit] */
export function getRelatedStories(id, limit = 3) {
  return STORIES.filter((story) => story.id !== id).slice(0, limit);
}
